<template>
  <div
    class="data-grid-row"
    :class="[
      rowClass,
      config?.hoverable && 'hover:bg-zinc-50 dark:hover:bg-zinc-700/50',
      clickable && 'cursor-pointer',
      config?.striped && index % 2 === 1 && 'bg-zinc-50/50 dark:bg-zinc-700/25',
    ]"
    @click="handleClick"
    data-testid="data-grid-row"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';

interface Props {
  index?: number;
  rowClass?: string;
  clickable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  index: 0,
  rowClass: '',
  clickable: false,
});

interface Emits {
  click: [];
}

const emit = defineEmits<Emits>();

const config = inject<any>('dataGridConfig');

const handleClick = () => {
  if (props.clickable) {
    emit('click');
  }
};
</script>

<style scoped>
.data-grid-row {
  @apply transition-colors;
  display: table-row;
}

.data-grid-row:hover {
  @apply bg-zinc-50 dark:bg-zinc-700/50;
}
</style>